
import Vue from "vue";
import AppPage from "@/components/layout-editor/Page.vue";
import { SaleLayout } from "@/utils/sale-layouts/sale-layout";
import AppRequirements from "./Requirements.vue";
import { Sale } from "@/models/base";

export default Vue.extend({
	props: {
		layout: {
			type: Object as ()=>SaleLayout,
			required: true
		},
		zoomLevel: Number,
		lang: String,
		showGrid: Boolean,
		contactGroupId: {
			type: Number,
			required: true
		},
		exampleDocument: {
			type: Object as ()=>Sale
		}
	},
	components: {
		AppPage,
		AppRequirements
	}
});
